import { render, staticRenderFns } from "./WinnerBoardModal.vue?vue&type=template&id=78685469"
import script from "./WinnerBoardModal.vue?vue&type=script&lang=js"
export * from "./WinnerBoardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports